import { apiPrefix } from '../constants'
import capitalize from '../common/formatters/capitalize'

export default entityName => ({
  [`add${capitalize(entityName)}`]: {
    type: 'post',
    url: `${apiPrefix}${entityName}`,
  },
  [`delete${capitalize(entityName)}`]: {
    type: 'delete',
    url: `${apiPrefix}${entityName}`,
  },
  [`get${capitalize(entityName)}s`]: {
    type: 'get',
    url: `${apiPrefix}${entityName}s`,
  },
  [`update${capitalize(entityName)}`]: {
    type: 'put',
    url: `${apiPrefix}${entityName}`,
  },
})
